type Period = {
  startTime?: string;
  endTime?: string;
  start?: string;
  end?: string;
};

export const getPeriodsInterval = (periods: Period[]) => ({
  startTime: periods[0].startTime || periods[0].start || '',
  endTime:
    periods[periods.length - 1].endTime || periods[periods.length - 1].end || ''
});
